import { render } from "./PPWeapon.vue?vue&type=template&id=78357d6a"
import script from "./PPWeapon.vue?vue&type=script&lang=js"
export * from "./PPWeapon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__